module.exports = __webpack_public_path__ + "static/media/tgs-logo.4bc33b52.png";